/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Loading_Country_DataInputs */

const bn_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দেশের ডেটা লোড হচ্ছে`)
};

const de_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Länderdaten werden geladen`)
};

const el_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Φόρτωση δεδομένων χώρας`)
};

const en_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading country data`)
};

const es_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando datos del país`)
};

const fr_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des données des pays`)
};

const hi_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देश का डेटा लोड हो रहा है`)
};

const hu_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Országadatok betöltése`)
};

const id_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat data negara`)
};

const it_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento dati paese`)
};

const ja_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国データのロード`)
};

const ko_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`국가 데이터 로드 중`)
};

const nl_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landgegevens laden`)
};

const pl_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ładowanie danych kraju`)
};

const pt_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando dados do país`)
};

const ru_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка данных о стране`)
};

const sv_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laddar landsdata`)
};

const tr_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ülke verileri yükleniyor`)
};

const uk_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантаження даних країни`)
};

const vi_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải dữ liệu quốc gia`)
};

const zh_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载国家/地区数据`)
};

const zh_hant_game_loading_country_data = /** @type {(inputs: Game_Loading_Country_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`載入國家/地區數據`)
};

/**
* | output |
* | --- |
* | "Loading country data" |
*
* @param {Game_Loading_Country_DataInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_loading_country_data = /** @type {((inputs?: Game_Loading_Country_DataInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Loading_Country_DataInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_loading_country_data(inputs)
	if (locale === "de") return de_game_loading_country_data(inputs)
	if (locale === "el") return el_game_loading_country_data(inputs)
	if (locale === "en") return en_game_loading_country_data(inputs)
	if (locale === "es") return es_game_loading_country_data(inputs)
	if (locale === "fr") return fr_game_loading_country_data(inputs)
	if (locale === "hi") return hi_game_loading_country_data(inputs)
	if (locale === "hu") return hu_game_loading_country_data(inputs)
	if (locale === "id") return id_game_loading_country_data(inputs)
	if (locale === "it") return it_game_loading_country_data(inputs)
	if (locale === "ja") return ja_game_loading_country_data(inputs)
	if (locale === "ko") return ko_game_loading_country_data(inputs)
	if (locale === "nl") return nl_game_loading_country_data(inputs)
	if (locale === "pl") return pl_game_loading_country_data(inputs)
	if (locale === "pt") return pt_game_loading_country_data(inputs)
	if (locale === "ru") return ru_game_loading_country_data(inputs)
	if (locale === "sv") return sv_game_loading_country_data(inputs)
	if (locale === "tr") return tr_game_loading_country_data(inputs)
	if (locale === "uk") return uk_game_loading_country_data(inputs)
	if (locale === "vi") return vi_game_loading_country_data(inputs)
	if (locale === "zh") return zh_game_loading_country_data(inputs)
	return zh_hant_game_loading_country_data(inputs)
});